import React,{useEffect} from 'react';
import { useLocation } from "react-router-dom"
import Header from '../header/Header';
import { useDispatch, useSelector } from "react-redux";
import CustomLoader from '../CustomLoader';

const Layout = (props) => {
    const location = useLocation();
    const permissions = useSelector(state=>state.auth.userPermissions)
    const isLoading = useSelector(state=>state.common.isLoading)


    return (
        <>
            <div className="content-wrapper">
                    <Header sideBarActive={props.sideBarActive}/>
                    {props.children}
                    {
                        isLoading && <CustomLoader/>
                    }
                    
            </div>
        </>
    )
}


// export class Layout extends Component {
//     const location = useLocation();
//     console.log(location.pathname);

//     render() {
//         return (
//             <Fragment>
//                 <div className="content-wrapper">
//                         <Header sideBarActive={this.props.sideBarActive}/>
//                         {this.props.children}
//                 </div>
//             </Fragment>
//         )
//     }
// }

export default Layout
